import React, { useEffect, useState } from "react";
import { Row, Col, Accordion, Card } from "react-bootstrap";
import { MdKeyboardArrowRight } from "react-icons/md";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";

import IncidentDetailsInfo from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Investigator/IncidentDetailsInfo";
import ReviewerDetailsInfo from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Reviewer/ReviewerDetailsInfo";
import { getIncidentReportById } from "app/_services/ehs/ehsIncidentServices";
import { contractorDropdownLabel, employeeDropdownLabel } from "app/_helpers/helper";
import { UserService } from "app/_services/UserService/UserService";
import { getAllAreaOfOperation } from "app/_services/ehs/ehsAreaOfOperationServices";
import toastr from "toastr";
import { getContractor } from "app/_services/Contractor/ContractorService";
import {
  FORM_LABEL_OFFICER,
  STAFFEMPLOYER,
  commentTypes,
  evidenceCategories,
  initialForm,
} from "app/_pages/_healthSafetyEnvironment/IncidentManagement/CONSTANTS";
import IncidentTimeline from "app/_pages/_healthSafetyEnvironment/IncidentManagement/IncidentTimeline";
import ViewComments from "app/_pages/_healthSafetyEnvironment/IncidentManagement/ViewComments";
import CapasViewTable from "app/_pages/_healthSafetyEnvironment/CapasViewTable";
const ViewIncidentReportsReview = ({
  match: {
    params: { id: incidentDetailsId },
  },
  history,
}) => {
  const [form, setForm] = useState({ ...initialForm });
  const [tab, setTab] = useState(1);
  const [evidences, setEvidences] = useState([]);
  const [comments, setComments] = useState([]);
  const [area, setArea] = useState([]);
  const [contractors, setContractors] = useState([]);

  const [currentReportLabel, setcurrentReportLabel] = useState("");
  const [capas, setCapas] = useState([]);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    getIncidentReportById(incidentDetailsId, "role=reviewer").then((response) => {
      if (!response?.status) {
        history.push("/health-safety-and-environment/incident-management");
        toastr.error(response?.message || "Something went Wrong");
        return;
      }
      if (!response?.data) return;

      setForm((prev) => {
        if (response.data.site?.siteType === 3) {
          prev.roName = response?.data?.site?.parentSite?.name;
          prev.roSiteId = response?.data?.site?.parentSite?.siteId;
        } else if (response?.data?.site?.siteType === 2) {
          prev.roName = response?.data?.site?.name;
          prev.roSiteId = response?.data?.site?.siteId;
        } else {
          prev.roName = "";
          prev.roSiteId = "";
        }

        return {
          ...prev,
          ...response.data,
          locationSiteId: response.data.site?.siteId,
          rootCauseAnalysisRequired: response.data.investigationDetails
            ?.rootCauseAnalysisRequired
            ? true
            : false,
        };
      });

      //setForm(response.data);
      setEvidences(
        response.data.evidences?.filter((data) => data.category === "Review") || []
      );
      setComments(
        response.data.comments?.filter((data) => data.type === commentTypes.review) || []
      );
      setcurrentReportLabel(response.data.reportAtLabel.toUpperCase());
      setCapas(response.data.capas);
    });

    UserService.getUsers("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setUsers(response.data);
    });

    getAllAreaOfOperation().then((response) => {
      if (!response?.data) return;
      setArea(response.data);
    });
  }, [incidentDetailsId]);

  useEffect(() => {
    getContractor().then((response) => {
      if (!response?.data) return;

      setContractors(response.data);
    });
  }, []);

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Reports", path: "#" },
          {
            name: "Incident Reports",
            path: "/reports/incident",
          },
          {
            name: "View",
          },
        ]}
      />
      <div className="healthSafetyEnvironmentWrapper">
        <div className="healthSafetyEnvironmentWrapper incidentMenu">
          <div className="hseMenuLinks card">
            <a
              onClick={() => setTab(1)}
              className={`pointer${tab === 1 ? " active" : ""}`}
              href
            >
              Timeline
            </a>
            {form.incidentReviewsData?.length > 0 && (
              <a
                onClick={() => setTab(2)}
                className={`pointer${tab === 2 ? " active" : ""}`}
                href
              >
                Workflow Inputs
              </a>
            )}

            {capas.length > 0 && (
              <a
                onClick={() => setTab(3)}
                className={`pointer${tab === 3 ? " active" : ""}`}
                href
              >
                CAPA
              </a>
            )}
          </div>
        </div>
      </div>
      <Row>
        {tab === 1 && (
          <Col lg={9}>
            <IncidentTimeline
              reportDate={form.reportDate}
              reporter={form.reporter}
              investigationCompletionDate={form.investigationCompletionDate}
              reviewCompletionDate={form.reviewCompletionDate}
              investigationDetails={form?.investigationDetails}
              reviewer={form.reviewer}
              closer={form.closer}
              personalDetails={form.personalDetails}
              vehicleDetails={form.vehicleDetails}
              assetDetails={form.assetDetails}
              spills={form.spills}
              evidences={evidences}
              investigationCompleted={form.investigationCompleted}
              reviewCompleted={form.reviewCompleted}
              closureCompleted={form.closureCompleted}
              isAssetIncident={form.isAssetIncident}
              isPersonalInjury={form.isPersonalInjury}
              isSpillsIncident={form.isSpillsIncident}
              isVehicleIncident={form.isVehicleIncident}
              closureCompletionDate={form.closureCompletionDate}
              incidentStatus={form.incidentStatus}
              insuranceApplicable={form.insuranceApplicable}
              complianceRequired={form.complianceRequired}
              trainingRequired={form.trainingRequired}
              witnessStatementRequired={form.witnessStatementRequired}
              rootCauseAnalysisRequired={form.rootCauseAnalysisRequired}
              solutionRequired={form.solutionRequired}
              capaRequired={form.capaRequired}
              reportEvidencesRequired={form.reportEvidencesRequired}
              evidencesRequired={form.evidencesRequired}
              reviewEvidencesRequired={form.reviewEvidencesRequired}
              incidentId={form.incidentId}
              incidentDate={form.incidentDate}
              type={form.type}
              severity={form.severity}
              severityPostReview={form.severityPostReview}
              workArea={form.workArea}
              site={form.site}
              department={form.department}
              isCapaPresent={form.capas ? form.capas.length : 0}
              capaCompletionDate={form?.capaCompletionDate}
              capaCompletedByData={form?.capaCompletedByData}
              finalReviewedByDate={form?.finalReviewedByDate}
              finalReviewedByData={form?.finalReviewedByData}
              reviewedByMMDate={form?.reviewedByMMDate}
              reviewedByMMData={form?.reviewedByMMData}
              reviewedDate={form?.reviewedDate}
              staffData={form?.staffData}
              staffType={form?.staffType}
              otherStaffName={form?.otherStaffName}
              area={form?.area}
              capasList={form?.capas}
              reportAtLabel={FORM_LABEL_OFFICER[form?.reportAtLabel]}
              form={form}
            />
          </Col>
        )}
        {tab === 2 && (
          <>
            <Col lg={9} className="pt-3">
              <ViewComments
                comments={form.incidentReviewsData ? form.incidentReviewsData : []}
              />
            </Col>
          </>
        )}
        {tab === 3 && (
          <Col lg={9}>
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
              <div className="simple-card-title">
                <h3 class="text-capitalize mb-0">CAPA</h3>
              </div>
              <div className="ehsFormWrapper">
                <div className="w-100">
                  {capas.length > 0 ? (
                    // <Capasview approveRejectView={false} capas={capas} />
                    <CapasViewTable capas={capas} />
                  ) : (
                    <div className="text-danger">Not Applicable</div>
                  )}
                </div>
              </div>
            </div>
          </Col>
        )}
        <Col lg={3}>
          <div className="mt-4">
            <Accordion>
              <div className="mb-3">
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey="10"
                  className="rightIncidentCard p-0"
                >
                  <div className="rightInfoTitle">
                    Reporter
                    <MdKeyboardArrowRight />
                  </div>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="10">
                  <Card.Body className="p-0">
                    <IncidentDetailsInfo
                      state={form.state}
                      longDurationFire={form.longDurationFire}
                      lostManhoursEmployees={form.lostManhoursEmployees}
                      lostManhoursContractors={form.lostManhoursContractors}
                      lostManhoursOthers={form.lostManhoursOthers}
                      department={form.department}
                      description={form.description}
                      equipmentFailure={form.equipmentFailure}
                      fallOfObject={form.fallOfObject}
                      inundation={form.inundation}
                      explosion={form.explosion}
                      facilityOutage={form.facilityOutage}
                      facilityShutdown={form.facilityShutdown}
                      facilityStatus={form.facilityStatus}
                      fatalityEmployees={form.fatalityEmployees}
                      fatalityContractors={form.fatalityContractors}
                      fatalityOthers={form.fatalityOthers}
                      fireInvolved={form.fireInvolved}
                      functionData={form.functionData}
                      incidentDate={form.incidentDate}
                      incidentId={form.incidentId}
                      incidentStatus={form.incidentStatus}
                      indirectLosses={form.indirectLosses}
                      injuredEmployees={form.injuredEmployees}
                      injuredContractors={form.injuredContractors}
                      injuredOthers={form.injuredOthers}
                      measuresOrActions={form.measuresOrActions}
                      peopleCount={form.peopleCount}
                      permanentDisability={form.permanentDisability}
                      reportDate={form.reportDate}
                      severity={form.severity}
                      reportedBy={form.reporter}
                      similarIncidentHappened={form.similarIncidentHappened}
                      summary={form.summary}
                      site={form.site}
                      workArea={form.workArea}
                      type={form.type}
                      personalDetails={form.personalDetails}
                      assetDetails={form.assetDetails}
                      vehicleDetails={form.vehicleDetails}
                      spills={form.spills}
                      evidences={form.evidences?.filter(
                        (data) => data.category === evidenceCategories.report
                      )}
                      regionalOffice={form.site ? form.site.parentSite : ""}
                      staffType={form.staffType}
                      staffEmployer={
                        form?.staffType === "contractor"
                          ? form?.StaffNameObject?.contractors?.contractorLegalEntity
                          : STAFFEMPLOYER.find((d) => d.id === form?.staffEmployer)
                              ?.contactPerson
                      }
                      staffName={
                        form?.staffType === "employee"
                          ? `${employeeDropdownLabel(form?.staffData)}`
                          : form?.staffType === "contractor"
                          ? `${contractorDropdownLabel(form?.staffData)}`
                          : form?.otherStaffName
                      }
                      area={form.area}
                      subArea={form.subArea}
                      subAreaId={form.subAreaId}
                      otherSubArea={form.otherSubArea}
                      shift={form.shift}
                      activity={form.activity}
                      subActivity={form.subActivity}
                      locationSiteId={form?.locationSiteId}
                      roSiteId={form?.roSiteId}
                      contractors={contractors}
                      alcoholViolator={form.alcoholViolator}
                      ppeViolator={form.ppeViolator}
                      unfitBuyerTruck={form.unfitBuyerTruck}
                      unfitHEMM={form.unfitHEMM}
                    />
                  </Card.Body>
                </Accordion.Collapse>
              </div>
              {form && form.severity > 3 && form.investigationDetails && (
                <div className="mb-3">
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey="11"
                    className="rightIncidentCard p-0"
                  >
                    <div className="rightInfoTitle">
                      Investigator <MdKeyboardArrowRight />
                    </div>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="11">
                    <Card.Body className="p-0">
                      <ReviewerDetailsInfo
                        investigationCompletionDate={
                          form.investigationDetails.investigationCompletionDate
                        }
                        investigationCompletionSummary={
                          form.investigationDetails.investigationCompletionSummary
                        }
                        severity={form.investigationDetails.severity}
                        insuranceApplicable={
                          form.investigationDetails.insuranceApplicable
                        }
                        insuranceClaimRaised={
                          form.investigationDetails.insuranceClaimRaised
                        }
                        insuranceClaimAmount={
                          form.investigationDetails.insuranceClaimAmount
                        }
                        insuranceApprovedAmount={
                          form.investigationDetails.insuranceApprovedAmount
                        }
                        insuranceUnapprovedAmount={
                          form.investigationDetails.insuranceUnapprovedAmount
                        }
                        cause={form.investigationDetails.cause}
                        fireCause={form.investigationDetails.fireCause}
                        avoidable={form.investigationDetailsavoidable}
                        couldAvoidBy={form.investigationDetails.couldAvoidBy}
                        environmentalImpact={
                          form.investigationDetails.environmentalImpact
                        }
                        solutionType={form.investigationDetails.solutionType}
                        compliances={form.investigationDetails.compliances}
                        trainings={form.investigationDetails.trainings}
                        mitigationMeasures={form.investigationDetails.mitigationMeasures}
                        witnessStatements={form?.witnessStatements}
                        rootCauseDescriptions={
                          form.investigationDetails.rootCauseDescriptions
                        }
                        immediateCause={form?.investigationDetails?.immediateCause}
                        indirectCause={form?.investigationDetails?.indirectCause}
                        causeIndirect={form?.causeIndirect}
                        causeIndirectOther={form?.causeIndirectOther}
                        causeImmediate={form?.causeImmediate}
                        causeImmediateOther={form?.causeImmediateOther}
                        solutions={form.investigationDetails.solutions}
                        capas={form.capas}
                        investigator={form.investigationDetails.investigator}
                        evidences={form.investigationDetails?.investigationEvidences?.filter(
                          (data) => data.category === evidenceCategories.investigation
                        )}
                        documents={form?.investigationDetails?.documents?.filter(
                          (data) =>
                            data.category === evidenceCategories.investigationOther
                        )}
                        comments={form.comments?.filter(
                          (data) => data.type === commentTypes.investigation
                        )}
                        incident={form}
                        users={users}
                        targetCompletionDate={
                          form?.investigationDetails?.targetCompletionDate
                        }
                        rootCause={form?.investigationDetails?.rootCause}
                        rootCauseOther={form?.investigationDetails?.rootCauseOther}
                        area={area}
                        severityPostReview={form?.severityPostReview}
                      />
                    </Card.Body>
                  </Accordion.Collapse>
                </div>
              )}
            </Accordion>
          </div>
        </Col>
      </Row>
      <div className="mt-4 text-center filterFormDivider">
        <span className="btn btn-secondary mx-2" onClick={() => history.goBack()}>
          Go Back
        </span>
      </div>
    </>
  );
};

export default ViewIncidentReportsReview;
